import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { StepLabel, Step, Stepper, makeStyles } from '@material-ui/core';
import CustomStepIcon from './CustomStepIcon/CustomStepIcon';
import CustomConnector from './CustomConnector/CustomConnector';
import { currentStepSelector, stepsSelector } from '../../store/selectors/formConfigSelectors';
import { showSummarySelector } from '../../store/selectors/globalConfigSelectors';

const useStepperStyles = makeStyles((theme) => ({
  root: {
    padding: `${theme.spacing(3)}px 0`,
  },
  step: {
    padding: 0,
  },
  iconContainer: {
    padding: 0,
  },
}));

const StepsNavigation = ({ formValues, validateForm }) => {
  const { currentStep, stepsLength, showSummary } = useSelector((state) => ({
    // formConfig state
    currentStep: currentStepSelector(state),
    stepsLength: stepsSelector(state)?.length,
    // globalConfig state
    showSummary: showSummarySelector(state),
  }));

  const classes = useStepperStyles();

  const numOfSteps = stepsLength + Number(showSummary);
  const stepsIndexArr = [...Array(numOfSteps).keys()];

  return (
    <Stepper className={classes.root} activeStep={currentStep} connector={<CustomConnector />}>
      {stepsIndexArr.map((step) => (
        <Step className={classes.step} key={step}>
          <StepLabel
            classes={{ iconContainer: classes.iconContainer }}
            StepIconComponent={CustomStepIcon}
            StepIconProps={{ formValues, validateForm }}
          />
        </Step>
      ))}
    </Stepper>
  );
};

StepsNavigation.propTypes = {
  validateForm: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  formValues: PropTypes.object,
};

StepsNavigation.defaultProps = {
  validateForm: null,
  formValues: {},
};

export default StepsNavigation;
